import { render, staticRenderFns } from "./CustomerRecentTransaction.vue?vue&type=template&id=5509ca36&scoped=true"
import script from "./CustomerRecentTransaction.vue?vue&type=script&lang=js"
export * from "./CustomerRecentTransaction.vue?vue&type=script&lang=js"
import style0 from "./CustomerRecentTransaction.vue?vue&type=style&index=0&id=5509ca36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509ca36",
  null
  
)

export default component.exports